"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Article = /** @class */ (function () {
    function Article() {
        this.config = {
            htmlElements: {
                toggle: null
            },
            nodeLists: {
                articles: null,
                toggles: null
            },
            classNames: {
                active: 'articles--active'
            },
            selectors: {
                article: '[data-article]',
                toggle: '[data-article-toggle]',
            }
        };
    }
    Article.prototype.init = function () {
        this.config.nodeLists.toggles = document.querySelectorAll(this.config.selectors.toggle);
        if (this.config.nodeLists.toggles.length)
            this.addEventListeners();
    };
    Article.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.toggles.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleClick.bind(_this, htmlElement)); });
    };
    Article.prototype.handleClick = function (htmlElement) {
        this.toggle(htmlElement);
    };
    Article.prototype.toggle = function (htmlElement) {
        htmlElement.closest(this.config.selectors.article).classList.toggle(this.config.classNames.active);
    };
    return Article;
}());
exports.default = new Article();
